/* @flow */

// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_REQUIRED_CONTRACT_PROPS = {
  abi: true,
  address: false,
  bytecode: false,
};
